<mat-form-field [formGroup]="group" class="full-width">
	<mat-label>{{ config.placeholder }}</mat-label>
	<textarea
		matInput
		placeholder="{{ config.placeholder }}"
		[formControlName]="config.name"></textarea>
</mat-form-field>
